import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const MinosParametersVuexModule = {
  namespaced: true,
  state: () => ({
    $_dataTypesApiPath: "v1.0/DataTypes",
    $_parameterCodesApiPath: "v1.0/ParameterCodes",
    $_parameterValuesApiPath: "v1.0/ParameterValues",
    $_parameterCodes: [],
    $_parameterValues: [],
    $_currentParameterCode: {},
    $_currentParameterValue: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    parameterCodes: (state) => state.$_parameterCodes,
    parameterValues: (state) => state.$_parameterValues,
    currentCode: (state) => state.$_currentParameterCode,
    currentValue: (state) => state.$_currentParameterValue,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    async getParameterCodes(
      { commit, dispatch, state, rootGetters },
      returnObject
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_parameterCodesApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      var shouldReturn = returnObject ?? false;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        if (!shouldReturn) commit("SET_PARAMETER_CODES", response.data);
        else return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getParameterCode({ commit, dispatch, state, rootGetters }, code) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl + state.$_parameterCodesApiPath + "/" + encodeURI(code);
      var axiosConfig = rootGetters.axiosConfig;

      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PARAMETER_CODE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getParameterValues({ commit, dispatch, state, rootGetters }, code) {
      var baseUrl = rootGetters.baseUrl;

      var actionLink = baseUrl + state.$_parameterValuesApiPath;
      if (code != undefined) actionLink = actionLink + "/" + encodeURI(code);
      var axiosConfig = rootGetters.axiosConfig;

      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PARAMETER_VALUES", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getParameterValuesByCode(
      { commit, dispatch, state, rootGetters },
      { code, returnObject }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var shouldReturn = returnObject ?? false;

      var actionLink = baseUrl + state.$_parameterValuesApiPath;
      if (code != undefined) actionLink = actionLink + "/" + encodeURI(code);
      var axiosConfig = rootGetters.axiosConfig;

      try {
        const response = await axios.get(actionLink, axiosConfig);
        if (!shouldReturn) commit("SET_PARAMETER_VALUES", response.data);
        else return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getParameterValue(
      { commit, dispatch, state, rootGetters },
      { code, subcode }
    ) {
      var baseUrl = rootGetters.baseUrl;

      var actionLink = baseUrl + state.$_parameterValuesApiPath;
      actionLink =
        actionLink + "/" + encodeURI(code) + "/" + encodeURI(subcode);

      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PARAMETER_VALUE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_PARAMETER_CODES(state, value) {
      state.$_parameterCodes = value;
    },
    SET_PARAMETER_VALUES(state, value) {
      state.$_parameterValues = value;
    },
    SET_PARAMETER_CODE(state, value) {
      state.$_currentParameterCode = value;
    },
    SET_PARAMETER_VALUE(state, value) {
      state.$_currentParameterValue = value;
    },

    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default MinosParametersVuexModule;
